// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3s6FH","info":"UpdateTermsInfo_info__1sbWG"};